module.exports = __webpack_public_path__ + "img/group.2b7ba345.svg";